<template>
  <div class="page">
    <PageHeader>
      Сайты
    </PageHeader>
    <div class="content">
      <el-card
        shadow="always"
        :body-style="{ padding: '20px' }"
        v-loading="loading"
      >
        <!-- <div slot="header">
        <span>Балансы</span>
      </div> -->
        <div v-if="sites.docs">
          <el-table
            :data="sites.docs"
            @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }"
            :row-class-name="tableRowClassName"
            border
            stripe
          >
            <el-table-column sortable="custom" prop="_id" label="ID" width="90">
              <template slot-scope="scope">
                <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
                {{ scope.row._id.slice(-6) }}
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="title" label="Название">
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="name"
              label="Имя"
              width="180"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="headerName"
              label="Заголовок"
              width="120"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="headerValueRegexp"
              label="Шаблон"
              width="180"
            >
            </el-table-column>
            <el-table-column
              v-if="session.type <= -1"
              fixed="right"
              label="Действия"
              width="150"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">Удалить</div>
                  <el-button
                    size="small"
                    icon="el-icon-delete"
                    @click="handleDeleteItem(scope.row._id)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="sites.page"
            :page-size="sites.limit"
            layout="prev, pager, next, jumper"
            :total="sites.totalDocs"
          >
          </el-pagination>
        </div>
        <el-collapse>
          <el-collapse-item name="1">
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              Добавить
            </template>
            <el-form
              :model="newSite"
              ref="form"
              label-width="80px"
              :inline="false"
              size="normal"
            >
              <el-form-item label="Название">
                <el-input v-model="newSite.title"></el-input>
              </el-form-item>
              <el-form-item label="Имя">
                <el-input v-model="newSite.name"></el-input>
              </el-form-item>
              <el-form-item label="Заголовок">
                <el-input v-model="newSite.headerName"></el-input>
              </el-form-item>
              <el-form-item label="Шаблон">
                <el-input v-model="newSite.headerValueRegexp"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addItem">Добавить</el-button>
                <el-button @click="resetForm">Очистить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  getSites,
  addSite,
  editSite,
  deleteSite,
  getLedgerValutes,
  getCredentials
} from "@/api";
import { mapState, mapActions, mapGetters } from "vuex";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "SitesPage",
  data: () => ({
    loading: true,
    newSite: {
      title: "",
      name: "",
      headerName: "",
      headerValueRegexp: ""
    },
    sites: [],
    page: 1,
    limit: 10,
    sort: "-_id"
  }),
  computed: {
    ...mapState("auth", ["session"])
  },
  methods: {
    async getSites() {
      try {
        this.loading = true;
        const { data } = await getSites({
          page: this.page,
          limit: this.limit,
          sort: this.sort
        });
        if (data.status) this.sites = data.result;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteItem(id) {
      let message = "Вы точно хотите удалить сайт?";
      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await deleteSite(id);
        await this.getSites();
        this.$message({
          type: "success",
          message: `Сайт успешно удален`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleSortChange(sortData) {
      this.sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.getSites();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getSites();
    },
    resetForm() {
      this.newSite = {
        title: "",
        name: "",
        headerName: "",
        headerValueRegexp: ""
      };
    },
    async addItem() {
      try {
        const data = {
          ...this.newSite
        };
        const resp = await addSite(data);
        await this.getSites();
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
          message: `Сайт ${resp.data.result.title || ""} создан!`
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    }
  },
  async mounted() {
    await this.getSites();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Sites/index.vue